import axios from 'axios';

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const apiClient = axios.create({
    baseURL: apiBaseUrl,
    headers: {
        'Content-Type': 'application/json',
      }
  });

  export const getAppData = async (url) =>{
try {
    const responce = await apiClient.get(url)
    return responce.data;
} catch (error) {
    console.error('Error fetching app data:', error);
    throw error;
}
  
  }